import { selectUserAddress } from 'modules/user/store/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';

import {
  selectIsPersonalAccountInitialized,
  selectIsPersonalAccountInitializing,
  selectPersonalAccount,
  selectPersonalAccountUserEndpointToken,
  selectPersonalAccountWorkerToken,
} from '../store/selectors';

export const usePersonalAccountState = () => {
  const { isLoggedIn } = useAuth();

  const userAddress = useAppSelector(selectUserAddress);

  const isInitialized =
    useAppSelector(state =>
      selectIsPersonalAccountInitialized(state, userAddress!),
    ) && isLoggedIn;
  const isInitializing = useAppSelector(state =>
    selectIsPersonalAccountInitializing(state, userAddress!),
  );
  const personalAccount = useAppSelector(selectPersonalAccount);
  const userEndpointToken = useAppSelector(state =>
    selectPersonalAccountUserEndpointToken(state, userAddress!),
  );
  const workerToken = useAppSelector(state =>
    selectPersonalAccountWorkerToken(state, userAddress!),
  );

  return {
    isInitialized,
    isInitializing,
    personalAccount,
    userEndpointToken,
    workerToken,
  };
};
